import React from 'react'
import logo from '../../assets/images/ElverveLogo.png';

const Logo = () => {
  return (

        <img
          className="logo"
          src={logo}
          alt="Elverve Logo"
          width="245"
          height="50"
        />
    // Triumphal blackcolor
  //   <svg className='logo' xmlns="http://www.w3.org/2000/svg" width="245" height="50" viewBox="0 0 245 50">
  //   <text x="0" y="35" fontFamily="Arial" fontSize="40" fill="white">Triumphal</text>
  // </svg>




  )
}

export default Logo
